/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PromoTokenRedemptionCallbackBody
 */
export interface PromoTokenRedemptionCallbackBody {
    /**
     * 
     * @type {string}
     * @memberof PromoTokenRedemptionCallbackBody
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenRedemptionCallbackBody
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenRedemptionCallbackBody
     */
    partnerUserId?: string;
}

/**
 * Check if a given object implements the PromoTokenRedemptionCallbackBody interface.
 */
export function instanceOfPromoTokenRedemptionCallbackBody(value: object): value is PromoTokenRedemptionCallbackBody {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PromoTokenRedemptionCallbackBodyFromJSON(json: any): PromoTokenRedemptionCallbackBody {
    return PromoTokenRedemptionCallbackBodyFromJSONTyped(json, false);
}

export function PromoTokenRedemptionCallbackBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromoTokenRedemptionCallbackBody {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'status': json['status'],
        'partnerUserId': json['partnerUserId'] == null ? undefined : json['partnerUserId'],
    };
}

export function PromoTokenRedemptionCallbackBodyToJSON(json: any): PromoTokenRedemptionCallbackBody {
    return PromoTokenRedemptionCallbackBodyToJSONTyped(json, false);
}

export function PromoTokenRedemptionCallbackBodyToJSONTyped(value?: PromoTokenRedemptionCallbackBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'status': value['status'],
        'partnerUserId': value['partnerUserId'],
    };
}

